/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
function confirmDialog({ callback, ...options }) {
    const defaultOptions = $('#confirmRemoveModalMetadata').data();
    const {
        title, message, okText, cancelText, okClass, cancelClass,
    } = $.extend({}, defaultOptions, options);

    $('<div id="confirmRemoveModal" class="modal" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content">' +
        '<div class="modal-header"><h5 class="modal-title">' + title + '</h5><button type="button"' +
        'class= "btn-close" data-bs-dismiss="modal" aria-label="Close" ></button > ' +
        '</div><div class="modal-body"><p>' + message + '</p></div><div class="modal-footer">' +
        '<button id="modalOkButton" type="button" class="btn ' + okClass + '">' + okText + '</button>' +
        '<button id="modalCancelButton" type="button" class="btn ' + cancelClass + '"data-bs-dismiss="modal">' +
        cancelText + '</button></div></div></div></div>').appendTo('body');

    const confirmModal = new bootstrap.Modal($('#confirmRemoveModal'), {
        backdrop: 'static',
        keyboard: false,
    });
    confirmModal.show();

    document.getElementById('confirmRemoveModal').addEventListener('hidden.bs.modal', () => {
        document.getElementById('confirmRemoveModal').remove();
        confirmModal.dispose();
    });

    $('#modalOkButton').click(() => {
        callback(true);
        confirmModal.hide();
    });

    $('#modalCancelButton').click(() => {
        callback(false);
        confirmModal.hide();
    });
}

function successDialog({ onhide, ...options }) {
    const { title, message } = $.extend({}, options);

    $('<div id="successDialog" class="modal fade"><div class= "modal-dialog modal-confirm">' +
        '<div class="modal-content"><div class="modal-header justify-content-center">' +
        '<div class="icon-box"><i class="fa fa-check" style="font-size:64px !important;"></i>' +
        '</div><button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">&times;</button>' +
        '</div><div class="modal-body text-center"><h4 id="successHeader">' + title + '</h4>' +
        '<p id="successMessage">' + message + '</p></div></div></div></div>').appendTo('body');

    const successModal = new bootstrap.Modal($('#successDialog'), {
        backdrop: 'static',
        keyboard: false,
    });

    successModal.show();

    $('#successDialog').on('hide.bs.modal', () => {
        if (onhide) { onhide(); }
    });

    document.getElementById('successDialog').addEventListener('hidden.bs.modal', () => {
        document.getElementById('successDialog').remove();
        successModal.dispose();
    });
}

function errorDialog({ ...options }) {
    const { title, message, modalClass } = $.extend({}, options);

    $('<div id="errorDialog" class="modal fade"><div class= "modal-dialog modal-confirm ' + modalClass + '">' +
        '<div class="modal-content"><div class="modal-header justify-content-center" style="background: #e85e6c;">' +
        '<div class="icon-box"><i class="fa fa-xmark" style="font-size:60px !important;"></i></div>' +
        '<button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">&times;</button></div>' +
        '<div class="modal-body text-center"><h4 id="errorHeader">' + title + '</h4><p id="errorMessage">' + message + '</p>' +
        ' </div></div></div></div>').appendTo('body');

    const errorModal = new bootstrap.Modal($('#errorDialog'), {
        backdrop: 'static',
        keyboard: false,
    });

    errorModal.show();

    document.getElementById('errorDialog').addEventListener('hidden.bs.modal', () => {
        document.getElementById('errorDialog').remove();
        errorModal.dispose();
    });
}

$(document).on('click', '.one-time-click', function () {
    $(this).css('pointer-events', 'none');
});
